import { FieldType } from 'checkout/enums/FieldType';
import { AddressTextField } from 'checkout/components/AddressForm/AddressTextField';
import StateDropdownField from 'checkout/components/AddressForm/StateDropdownField';
import { COUNTRY_ISO_CODES } from 'checkout/enums/CountryIsoCodes';
import { IMenuItem } from 'shared/types/MenuItem';

type IAddressFormFieldProps = {
  type: FieldType;
  label?: string;
  name?: string;
  countryIsoCode?: COUNTRY_ISO_CODES;
  selectedState?: IMenuItem;
  onMenuItemClick?: (IMenuItem) => void;
};

export const AddressFormField = ({
  type,
  label,
  name,
  countryIsoCode,
  selectedState,
  onMenuItemClick,
  ...props
}: IAddressFormFieldProps) => {
  switch (type) {
    case FieldType.StreetAddress:
    case FieldType.UnitNumber:
    case FieldType.City:
    case FieldType.PostalCode:
    case FieldType.Phone:
      return <AddressTextField label={label} name={name} type={type} {...props} />;
    case FieldType.State:
      return (
        <StateDropdownField
          countryIsoCode={countryIsoCode}
          selectedState={selectedState}
          onMenuItemClick={onMenuItemClick}
          label={label}
          {...props}
        />
      );
    default:
      return null;
  }
};
